"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.withBlockTracker = void 0;
const block_tracker_service_1 = require("@app/services/block-tracker.service");
const block_tracking_reducer_1 = require("@app/store/reducers/block-tracking.reducer");
const promise_1 = require("@utils/promise");
const react_1 = __importStar(require("react"));
const blockTrackerService = new block_tracker_service_1.BlockTrackerService();
const withBlockTracker = (WrappedComponent) => {
    return (props) => {
        const updateBlockTracker = (0, block_tracking_reducer_1.useUpdateTracker)();
        (0, react_1.useEffect)(() => {
            updateBlockTracker({ blocksForTracking: blockTrackerService.getList() || {} });
            const awaiter = new promise_1.ActionAwaiter();
            awaiter.resolve(undefined);
            blockTrackerLoop(updateBlockTracker, awaiter);
        });
        return react_1.default.createElement(WrappedComponent, Object.assign({}, props));
    };
};
exports.withBlockTracker = withBlockTracker;
const blockTrackerLoop = (updateBlockTracker, actionAwaiter) => __awaiter(void 0, void 0, void 0, function* () {
    yield actionAwaiter.promise;
    const blockNumber = yield blockTrackerService.getLatestSyncedBlock();
    const { notCompleted } = blockTrackerService.removeOperationsByBlock(blockNumber);
    updateBlockTracker({ latestSyncedBlock: blockNumber, blocksForTracking: notCompleted });
    actionAwaiter.recreate();
    setTimeout(() => actionAwaiter.resolve(undefined), 4000);
    blockTrackerLoop(updateBlockTracker, actionAwaiter);
});
